document.addEventListener("DOMContentLoaded", () => {
  const track = document.getElementById("shopify-carousel-track");
  if (!track) return;

  let position = 0;
  const speed = 0.4; // velocidad

  function move() {
    position += speed;

    if (position >= track.scrollWidth / 2) {
      position = 0;
    }

    track.style.transform = `translateX(${position}px)`;
    requestAnimationFrame(move);
  }

  move();
});
